'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactQuery = require('react-query');
var generated = require('../../../graphql/generated.js');
var PudoRaw = require('./PudoRaw.js');
var useReturns = require('../../../hooks/useReturns.js');
var useCurrencyConfig = require('../../../hooks/useCurrencyConfig.js');
var ReturnsConfigProvider = require('../../../providers/ReturnsConfigProvider.js');
var pudoMethod = require('../../../transformers/pudoMethod.js');
var helpers = require('./helpers.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Pudo = _ref => {
  var _returnCart$customer, _returnCart$customer$, _returnCart$customer2, _returnCart$customer3, _returnCart$customer4;
  let {
    headerTitle,
    onChange,
    onSubmit,
    onReset,
    onError,
    onBack
  } = _ref;
  const {
    returnCart,
    client,
    selectedPudoOption,
    setSelectedPudoOption,
    setReturnCart,
    selectedItems,
    orderData,
    localeCountry
  } = useReturns["default"]();
  const {
    locale,
    includeCurrency
  } = useCurrencyConfig["default"]();
  const {
    isHipaaCompliant
  } = ReturnsConfigProvider.useReturnsConfig();
  const initialPostalCode = (returnCart === null || returnCart === void 0 ? void 0 : (_returnCart$customer = returnCart.customer) === null || _returnCart$customer === void 0 ? void 0 : (_returnCart$customer$ = _returnCart$customer.shippingAddress) === null || _returnCart$customer$ === void 0 ? void 0 : _returnCart$customer$.postalCode) || (returnCart === null || returnCart === void 0 ? void 0 : (_returnCart$customer2 = returnCart.customer) === null || _returnCart$customer2 === void 0 ? void 0 : (_returnCart$customer3 = _returnCart$customer2.billingAddress) === null || _returnCart$customer3 === void 0 ? void 0 : _returnCart$customer3.postalCode);
  const [pudoOptions, setPudoOptions] = React.useState(undefined);
  const [sortedBy, setSortedBy] = React.useState();
  const [sortedByOptions, setSortedByOptions] = React.useState();
  const [locations, setLocations] = React.useState();
  const [postalCode, setPostalCode] = React.useState(initialPostalCode);
  const {
    error,
    mutate: createCartAndGetPudo,
    isLoading: loading
  } = reactQuery.useMutation({
    mutationFn: async () => {
      if (!client) throw new Error('Client not initialized');
      setSelectedPudoOption(undefined);
      const mutationVars = {
        initialReturnCart: {
          items: selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map(_ref2 => {
            let {
              quantity,
              reason,
              sku,
              itemId,
              name,
              price,
              variant,
              customerComments,
              categories,
              imageUrl,
              returnAction
            } = _ref2;
            return {
              quantity,
              reason,
              sku,
              itemId,
              name,
              price,
              variant,
              customerComments,
              categories,
              imageUrl,
              returnAction
            };
          }),
          orderId: (orderData === null || orderData === void 0 ? void 0 : orderData.orderId) || '',
          locale
        }
      };
      let mutation;
      if (isHipaaCompliant) {
        mutation = await client.mutate({
          mutation: generated.HipaaCreateReturnCartDocument,
          variables: mutationVars
        });
      } else {
        mutation = await client.mutate({
          mutation: generated.CreateReturnCartDocument,
          variables: mutationVars
        });
      }
      const {
        data: mutationData
      } = mutation;
      if (!(mutationData !== null && mutationData !== void 0 && mutationData.createReturnCart)) throw new Error('Unable to create a return cart');
      const {
        id: returnCartId
      } = mutationData.createReturnCart;
      const {
        customer
      } = mutationData.createReturnCart;
      const {
        data: pudoData
      } = await client.query({
        query: generated.GetPudoOptionsDocument,
        variables: {
          returnCartId
        }
      });
      if (!pudoData.getPudoOptions) throw new Error('Unable to fetch PUDO options');
      setReturnCart(mutationData.createReturnCart);
      setPudoOptions(pudoData.getPudoOptions);
      if (customer) {
        var _customer$shippingAdd, _customer$billingAddr;
        setPostalCode((customer === null || customer === void 0 ? void 0 : (_customer$shippingAdd = customer.shippingAddress) === null || _customer$shippingAdd === void 0 ? void 0 : _customer$shippingAdd.postalCode) || (customer === null || customer === void 0 ? void 0 : (_customer$billingAddr = customer.billingAddress) === null || _customer$billingAddr === void 0 ? void 0 : _customer$billingAddr.postalCode));
      }
      if (pudoData.getPudoOptions.length === 1) {
        var _preselectedOption$dr, _preselectedOption$dr2, _preselectedOption$dr3, _preselectedOption$dr4, _preselectedOption$dr5, _preselectedOption$dr6, _preselectedOption$dr7, _preselectedOption$dr8;
        const preselectedOption = pudoData.getPudoOptions[0];
        const preselectedLocation = (_preselectedOption$dr = preselectedOption.dropOff) === null || _preselectedOption$dr === void 0 ? void 0 : (_preselectedOption$dr2 = _preselectedOption$dr.sortedLocations) === null || _preselectedOption$dr2 === void 0 ? void 0 : _preselectedOption$dr2.locationsList[0];
        setSelectedPudoOption({
          pudoActionType: preselectedOption.pudoActionType,
          pudoActionTypeDetails: preselectedOption.pudoActionTypeDetails,
          pudoProvider: preselectedOption.pudoProvider,
          title: preselectedOption.title,
          description: preselectedOption.description,
          fees: preselectedOption.fees,
          serviceType: preselectedOption.serviceType,
          discounts: preselectedOption.discounts,
          narvarPudoInstructions: preselectedOption.narvarPudoInstructions,
          selectedDropOff: preselectedLocation && {
            selectedLocation: {
              id: preselectedLocation.id
            }
          }
        });
        setSortedBy((_preselectedOption$dr3 = preselectedOption.dropOff) === null || _preselectedOption$dr3 === void 0 ? void 0 : (_preselectedOption$dr4 = _preselectedOption$dr3.sortedLocations) === null || _preselectedOption$dr4 === void 0 ? void 0 : _preselectedOption$dr4.sortedBy);
        setSortedByOptions((_preselectedOption$dr5 = preselectedOption.dropOff) === null || _preselectedOption$dr5 === void 0 ? void 0 : (_preselectedOption$dr6 = _preselectedOption$dr5.sortedLocations) === null || _preselectedOption$dr6 === void 0 ? void 0 : _preselectedOption$dr6.availableSortOptions);
        setLocations((_preselectedOption$dr7 = preselectedOption.dropOff) === null || _preselectedOption$dr7 === void 0 ? void 0 : (_preselectedOption$dr8 = _preselectedOption$dr7.sortedLocations) === null || _preselectedOption$dr8 === void 0 ? void 0 : _preselectedOption$dr8.locationsList);
      }
    }
  });
  const createCartAndGetPudoRef = React.useRef(createCartAndGetPudo);
  React.useEffect(() => {
    createCartAndGetPudoRef.current();
  }, []);
  const {
    mutate: getLocationsQuery,
    isLoading: loadingLocations
  } = reactQuery.useMutation({
    mutationFn: async e => {
      if (!client) throw new Error('Client not initialized');
      const sortByQuery = e.sortedBy ?? sortedBy;
      const postalCodeQuery = e.postalCode ?? postalCode ?? '';
      await helpers.setPudoOption({
        client,
        isHipaaCompliant,
        selectedPudoOption,
        returnCart
      });
      const {
        data
      } = await client.query({
        query: generated.GetLocationsDocument,
        variables: {
          returnCartId: (returnCart === null || returnCart === void 0 ? void 0 : returnCart.id) ?? '',
          locationQuery: {
            address: {
              postalCode: postalCodeQuery,
              countryCode: localeCountry
            },
            sortBy: sortByQuery && [sortByQuery]
          }
        }
      });
      const newLocations = data.getLocations;
      setLocations(newLocations);
      setSelectedPudoOption({
        ...selectedPudoOption,
        selectedDropOff: {
          selectedLocation: newLocations.length > 0 ? {
            id: newLocations[0].id
          } : undefined
        }
      });
    }
  });

  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/require-await, @typescript-eslint/no-misused-promises
  const changePostalCode = async _ref3 => {
    let {
      value
    } = _ref3;
    setPostalCode(value === null || value === void 0 ? void 0 : value.postalCode);
    getLocationsQuery({
      postalCode: value === null || value === void 0 ? void 0 : value.postalCode
    });
    onChange === null || onChange === void 0 ? void 0 : onChange({
      event: 'change',
      area: 'pudo',
      subComponent: 'postalCode',
      value: {
        selectedCategory: undefined,
        postalCode: value === null || value === void 0 ? void 0 : value.postalCode
      }
    });
  };
  const nestedOptions = category => {
    var _category$dropOff, _category$dropOff2;
    return [locations && locations.length > 0, (category === null || category === void 0 ? void 0 : (_category$dropOff = category.dropOff) === null || _category$dropOff === void 0 ? void 0 : _category$dropOff.locations) && (category === null || category === void 0 ? void 0 : (_category$dropOff2 = category.dropOff) === null || _category$dropOff2 === void 0 ? void 0 : _category$dropOff2.locations.length) > 0, category === null || category === void 0 ? void 0 : category.pickup].some(x => x);
  };

  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/require-await, @typescript-eslint/no-misused-promises
  const changeCategory = async event => {
    var _event$value;
    const selectedCategory = (_event$value = event.value) === null || _event$value === void 0 ? void 0 : _event$value.selectedCategory;
    const reference = pudoOptions === null || pudoOptions === void 0 ? void 0 : pudoOptions.find(option => pudoMethod.generatePudoId(option) === pudoMethod.generatePudoId(selectedCategory));
    if (selectedCategory && reference) {
      var _reference$dropOff, _reference$dropOff$so, _reference$dropOff2, _reference$dropOff2$s, _reference$dropOff3, _reference$dropOff3$s;
      setSelectedPudoOption(selectedCategory);
      if (!sortedBy) setSortedBy((_reference$dropOff = reference.dropOff) === null || _reference$dropOff === void 0 ? void 0 : (_reference$dropOff$so = _reference$dropOff.sortedLocations) === null || _reference$dropOff$so === void 0 ? void 0 : _reference$dropOff$so.sortedBy);
      if (!sortedByOptions) setSortedByOptions((_reference$dropOff2 = reference.dropOff) === null || _reference$dropOff2 === void 0 ? void 0 : (_reference$dropOff2$s = _reference$dropOff2.sortedLocations) === null || _reference$dropOff2$s === void 0 ? void 0 : _reference$dropOff2$s.availableSortOptions);
      if (!locations) setLocations((_reference$dropOff3 = reference.dropOff) === null || _reference$dropOff3 === void 0 ? void 0 : (_reference$dropOff3$s = _reference$dropOff3.sortedLocations) === null || _reference$dropOff3$s === void 0 ? void 0 : _reference$dropOff3$s.locationsList);
      if (nestedOptions(reference)) {
        onChange === null || onChange === void 0 ? void 0 : onChange({
          event: 'change',
          area: 'pudo',
          value: {
            selectedCategory
          },
          subComponent: 'category'
        });
      } else {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
          event: 'submit',
          area: 'pudo',
          value: {
            selectedCategory: selectedPudoOption
          }
        });
      }
    }
  };

  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/require-await, @typescript-eslint/no-misused-promises
  const changeSortedBy = async _ref4 => {
    let {
      value
    } = _ref4;
    setSortedBy(value === null || value === void 0 ? void 0 : value.sortedBy);
    getLocationsQuery({
      sortedBy: value === null || value === void 0 ? void 0 : value.sortedBy
    });
    onChange === null || onChange === void 0 ? void 0 : onChange({
      value: {
        sortedBy: value === null || value === void 0 ? void 0 : value.sortedBy
      },
      event: 'change',
      area: 'pudo',
      subComponent: 'locationSort'
    });
  };

  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  const handleChange = async event => {
    if (event.subComponent === 'postalCode') changePostalCode(event);
    if (event.subComponent === 'locationSort') changeSortedBy(event);
    if (event.subComponent === 'category' || event.subComponent === 'location') changeCategory(event);
  };

  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/require-await, @typescript-eslint/no-misused-promises
  const handleReset = async event => {
    setSelectedPudoOption === null || setSelectedPudoOption === void 0 ? void 0 : setSelectedPudoOption(undefined);
    setLocations(undefined);
    setPostalCode(initialPostalCode);
    onReset === null || onReset === void 0 ? void 0 : onReset(event);
  };

  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/require-await, @typescript-eslint/no-misused-promises
  const handleSubmit = async event => {
    if (event.subComponent === 'category') {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
        event: 'submit',
        area: 'pudo',
        value: {
          selectedCategory: selectedPudoOption
        }
      });
    }
  };

  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/require-await, @typescript-eslint/no-misused-promises
  const handleOnBack = async event => {
    if (selectedPudoOption && pudoOptions && pudoOptions.length > 1) {
      handleReset({
        value: {},
        area: 'pudo',
        subComponent: 'category',
        event: 'reset'
      });
    } else {
      onBack === null || onBack === void 0 ? void 0 : onBack(event);
    }
  };
  if (!pudoOptions || error) {
    onError === null || onError === void 0 ? void 0 : onError({
      event: 'error',
      area: 'pudo',
      error: {
        code: 'noPudoOptions',
        description: 'No Pudo Options Found'
      }
    });
  }
  return /*#__PURE__*/React__default["default"].createElement(PudoRaw.PudoRaw, {
    error,
    loading,
    loadingLocations,
    locale,
    includeCurrency,
    pudoOptions,
    postalCode,
    selectedCategory: selectedPudoOption,
    locations,
    sortedBy,
    sortedByOptions,
    headerTitle,
    returnAddress: returnCart === null || returnCart === void 0 ? void 0 : (_returnCart$customer4 = returnCart.customer) === null || _returnCart$customer4 === void 0 ? void 0 : _returnCart$customer4.pickupAddress,
    onSubmit: handleSubmit,
    onReset: handleReset,
    onChange: handleChange,
    onBack: handleOnBack
  });
};

exports.PudoRaw = PudoRaw.PudoRaw;
exports.Pudo = Pudo;
